import { Component, Input, ViewChild, ElementRef } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import Sortable from "sortablejs";

@Component({
  selector: "app-pdf-thumbnail-list-modal",
  templateUrl: "./pdf-thumbnail-list-modal.component.html",
  styleUrls: ["pdf-thumbnail-list-modal.component.css"],
})
export class pdfThumbnailListModalModalComponent {
  constructor(public activeModal: NgbActiveModal) {}

  @ViewChild("thumbWrapper") thumbWrapper: ElementRef;

  // PDFファイル
  @Input() pdfFiles: File[] = [];
  // サムネイル
  @Input() thumbnails: string[] = [];

  ret: any = {
    status: "",
    pdf: [],
    thumbnails: [],
  };

  ngAfterViewInit() {
    this.initSortable();
  }

  /**
   * モーダルを閉じる
   */
  close() {
    this.ret.status = "close";
    this.activeModal.close(this.ret);
  }

  /**
   * 後処理がある場合の処理（モーダルは閉じる）
   */
  processing() {
    this.ret.status = "ok";
    this.ret.pdf = this.pdfFiles;
    this.ret.thumbnails = this.thumbnails;
    this.activeModal.close(this.ret);
  }

  /** ▼ SortableJS：並び替え */
  initSortable() {
    Sortable.create(this.thumbWrapper.nativeElement, {
      animation: 150,
      // ★ ボタン等はドラッグ開始させない
      filter: "button, .btn, a, input, textarea, select",
      // ★ filter対象で preventDefault しない（click を生かす）
      preventOnFilter: false,
      onEnd: (evt) => {
        const oldIndex = evt.oldIndex;
        const newIndex = evt.newIndex;
        if (oldIndex == null || newIndex == null) return;

        const movedPdf = this.pdfFiles.splice(oldIndex, 1)[0];
        this.pdfFiles.splice(newIndex, 0, movedPdf);
        const movedThumb = this.thumbnails.splice(oldIndex, 1)[0];
        this.thumbnails.splice(newIndex, 0, movedThumb);
      },
    });
  }

  /** ▼ 削除 */
  removePdf(index: number) {
    this.pdfFiles.splice(index, 1);
    this.thumbnails.splice(index, 1);
  }

  /** ▼ 詳細（処理があれば） */
  viewPdf(i: number) {
    alert(this.pdfFiles[i].name + " を開きます（実装自由）");
  }
}



// WEBPACK FOOTER //
// ./src/app/parts/pdf/pdf-thumbnail-list-modal/pdf-thumbnail-list-modal.component.ts